import { PureComponent } from 'react';
import { ToastContainer } from 'react-toastify';
import cns from 'classnames';
import PropTypes from 'prop-types';

import './styles.global.less';
import cn from './styles.local.less';

export default class Notification extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  };

  render() {
    const { className } = this.props;

    return (
      <div className={cns(cn.root, className)}>
        <ToastContainer />
      </div>
    );
  }
}

export { toast as notify } from 'react-toastify';
